var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrossGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1958_7587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8049 0.195679C15.6799 0.0706986 15.5103 0.000488281 15.3336 0.000488281C15.1568 0.000488281 14.9872 0.0706986 14.8622 0.195679L8.00022 7.05768L1.13822 0.195679C1.01321 0.0706986 0.843667 0.000488281 0.666891 0.000488281C0.490114 0.000488281 0.320576 0.0706986 0.195557 0.195679C0.0705765 0.320698 0.000366211 0.490236 0.000366211 0.667013C0.000366211 0.843789 0.0705765 1.01333 0.195557 1.13835L7.05756 8.00035L0.195557 14.8623C0.0705765 14.9874 0.000366211 15.1569 0.000366211 15.3337C0.000366211 15.5105 0.0705765 15.68 0.195557 15.805C0.320576 15.93 0.490114 16.0002 0.666891 16.0002C0.843667 16.0002 1.01321 15.93 1.13822 15.805L8.00022 8.94301L14.8622 15.805C14.9872 15.93 15.1568 16.0002 15.3336 16.0002C15.5103 16.0002 15.6799 15.93 15.8049 15.805C15.9299 15.68 16.0001 15.5105 16.0001 15.3337C16.0001 15.1569 15.9299 14.9874 15.8049 14.8623L8.94289 8.00035L15.8049 1.13835C15.9299 1.01333 16.0001 0.843789 16.0001 0.667013C16.0001 0.490236 15.9299 0.320698 15.8049 0.195679Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1958_7587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrossGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross-grey.a64d1ea25533804f820da15c6f98276c.svg";